import PropTypes from 'prop-types';
import {
  Image,
  mediaBreakpointMixin,
  PropertyCard,
  StyledPropertyCardBody,
  StyledPropertyCardDataWrapper,
  Text,
  token,
} from '@zillow/constellation';
import React from 'react';
import styled from 'styled-components';
import images from '../../../images/ztss';
import { ZTSS_DASHBOARD } from '../../../constants/paths';
import UnstyledLink from '../../../components/UnstyledLink';

const StyledPropertyCard = styled(PropertyCard)`
  width: auto;
  min-width: fit-content;
  max-width: none;

  ${StyledPropertyCardBody} {
    min-height: 96px;
    min-width: 288px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);

    &:hover {
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    }

    @media ${mediaBreakpointMixin('md')} {
      min-width: 373px;
    }
  }

  ${StyledPropertyCardDataWrapper} {
    padding: ${token('spacing.xs')}px;
  }
`;

const StyledPhotoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  background-color: white;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

export default function Property({ photoUrl, listingAlias, address: { city, state, street, unit, zip } }) {
  const streetWithUnit = `${street}${unit ? `, ${unit}` : ''}`;
  const cityStateZip = `${city}, ${state} ${zip}`;
  return (
    <UnstyledLink to={`${ZTSS_DASHBOARD}?propertyId=${listingAlias}`}>
      <StyledPropertyCard
        id="ztss-property"
        appearance="flag"
        data={{
          title: <Text fontType="h6">{streetWithUnit}</Text>,
          body1: <Text>{cityStateZip}</Text>,
          body3: <Text fontColor="brand">Manage applications</Text>,
        }}
        photoBody={
          <PropertyCard.Photo
            src={photoUrl}
            fallbackImg={
              <StyledPhotoContainer>
                <Image src={images.noPhotoForProperty} padding="sm" alt="house" />
              </StyledPhotoContainer>
            }
            alt={photoUrl ? 'property photo' : 'house icon'}
          />
        }
      />
    </UnstyledLink>
  );
}

Property.propTypes = {
  photoUrl: PropTypes.string,
  listingAlias: PropTypes.string.isRequired,
  address: PropTypes.shape({
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    unit: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
  }),
};
